module.exports = __webpack_public_path__ + "img/del.521f4981.svg";